// Met à jour l'étiquette bestseller dynamiquement lors du changement de variante
(function() {
  // ===== FONCTIONS DE MISE À JOUR =====
  function updateRadioBadge(input) {
    const etiquette = input.getAttribute('data-etiquette');
    const label = input.nextElementSibling;

    if (!label || !label.classList.contains('swatch-block')) {
      return;
    }

    // Afficher le badge du bouton
    if (etiquette && etiquette.trim() !== '') {
      let badge = label.querySelector('.variant-bestseller-badge');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'variant-bestseller-badge';
        label.appendChild(badge);
      }
      badge.textContent = etiquette;
      badge.style.display = 'inline-block';
    }
  }

  function updateSelectBadge(select) {
    const selectedOption = select.options[select.selectedIndex];
    if (!selectedOption) return;

    const formInput = select.closest('.product-form__input');
    if (!formInput) return;

    // Masquer tous les badges existants
    const allBadges = formInput.querySelectorAll('.variant-bestseller-badge, .variant-dropdown-badge');
    allBadges.forEach(badge => {
      badge.style.display = 'none';
    });

    // Vérifier si l'option contient une étiquette (format: "Valeur - Bestseller")
    const optionText = selectedOption.textContent;
    if (optionText.includes(' - ')) {
      let badgeContainer = formInput.querySelector('.variant-dropdown-badge');
      if (!badgeContainer) {
        badgeContainer = document.createElement('div');
        badgeContainer.className = 'variant-dropdown-badge';
        formInput.appendChild(badgeContainer);
      }
      const etiquetteText = optionText.split(' - ').pop();
      badgeContainer.textContent = etiquetteText;
      badgeContainer.style.display = 'inline-block';
    }
  }

  // ===== FONCTIONS API =====
  function getProductId() {
    // Chercher dans l'URL
    const urlMatch = window.location.pathname.match(/\/products\/([^/?]+)/);
    if (urlMatch) return urlMatch[1];
    return null;
  }

  function fetchAndApplyMetafields(productHandle) {
    console.log('Récupération des metafields pour:', productHandle);

    fetch(`/products/${productHandle}.json`)
      .then(response => response.json())
      .then(data => {
        if (data.product && data.product.id) {
          fetchMetafieldsViaGraphQL(`gid://shopify/Product/${data.product.id}`);
        }
      })
      .catch(err => {
        console.log('Erreur:', err);
      });
  }

  function fetchMetafieldsViaGraphQL(productGid) {
    const query = `{
      product(id: "${productGid}") {
        variants(first: 100) {
          edges {
            node {
              option1
              option2
              option3
              metafields(first: 10, namespace: "custom") {
                edges {
                  node {
                    key
                    value
                  }
                }
              }
            }
          }
        }
      }
    }`;

    fetch('/api/2024-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query })
    })
      .then(response => response.json())
      .then(data => {
        if (data.data?.product?.variants) {
          applyMetafieldsToOptions(data.data.product.variants.edges);
        }
      })
      .catch(err => {
        console.log('Erreur GraphQL:', err);
      });
  }

  function applyMetafieldsToOptions(variantEdges) {
    const etiquetteMap = {};

    variantEdges.forEach(edge => {
      const variant = edge.node;
      const etiquetteField = variant.metafields?.edges?.find(m => m.node.key === 'etiquette_variant');

      if (etiquetteField?.node.value) {
        const etiquette = etiquetteField.node.value;

        // Stocker par option1, option2, option3
        if (variant.option1) etiquetteMap[variant.option1] = etiquette;
        if (variant.option2) etiquetteMap[variant.option2] = etiquette;
        if (variant.option3) etiquetteMap[variant.option3] = etiquette;
      }
    });

    // Appliquer aux inputs
    const allRadios = document.querySelectorAll('input[type="radio"]');
    allRadios.forEach(radio => {
      if (etiquetteMap[radio.value]) {
        radio.setAttribute('data-etiquette', etiquetteMap[radio.value]);
        updateRadioBadge(radio);
      }
    });
  }

  // ===== INITIALISATION =====
  function init() {
    const productHandle = getProductId();
    if (productHandle) {
      fetchAndApplyMetafields(productHandle);
    }
  }

  // Initialiser au chargement
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Écouter les changements
  document.addEventListener('change', function(event) {
    const input = event.target;

    if (input.type === 'radio' && input.hasAttribute('data-etiquette')) {
      updateRadioBadge(input);
    }

    if (input.tagName === 'SELECT') {
      updateSelectBadge(input);
    }
  });
})();
